export const PREVIEW_COLORS = {
  primaryBlue: '#01A7C8',
  darkBlue: '#007CAD',
  lightestBlue: '#DBF7F8',
  lighterBlue: '#C7EDEF',
  gray6: '#1B2831',
  gray5: '#323B46',
  gray4: '#4D5762',
  gray3: '#A9B7BE',
  white: '#FFFFFF',
  headerBg: '#01A7C8',
  footerBg: '#C7EDEF',
  navActive: '#1B2831',
  navInactive: '#007CAD',
  infoBoxBg: '#DBF7F8',
  infoBoxText: '#007CAD',
  stepNumberBg: '#01A7C8',
  stepNumberText: '#DBF7F8',
  textPrimary: '#1B2831',
  textBody: '#323B46',
  textSecondary: '#4D5762',
  tagText: '#007CAD',
  tagDivider: '#A9B7BE',
};

export const PREVIEW_SPACING = {
  pagePadding: 24,
  sectionGap: 16,
  elementGap: 8,
  cardPadding: 16,
  stepNumberSize: 24,
  imageHeight: 197,
  headerHeight: 77,
  footerHeight: 72,
};

export const PREVIEW_RADIUS = {
  container: 24,
  image: 12,
  card: 24,
  stepBadge: 12,
  infoBox: 16,
  footer: 36,
};

export const STAGE_COLORS = [
  { bg: '#DCEFE7', text: '#28564A', label: 'L1' },
  { bg: '#B7DFD0', text: '#1F4C40', label: 'L2' },
  { bg: '#84C6B1', text: '#123B31', label: 'L3' },
  { bg: '#4B9F87', text: '#ffffff', label: 'L4' },
  { bg: '#20544A', text: '#ffffff', label: 'L5' },
];
